import React from 'react'
import Button from '../../utils/Button'
import ErrorInputWrap from '../../utils/error-success/ErrorInputWrap'

const AdminManagersForm = ({data, loading, errors, handleInputChange, handleAddManager}) => {
    return (
        <div className="fieldset">
			<div className="title-label">Add New Specialist</div>

            <div className="fieldset-indent">
                <div className="form-field">
                    <label>Email</label>
                    <ErrorInputWrap error={errors.email}>
                        <input 
                            type="text" 
                            id="email"
                            value={data.email || ''}
                            onChange={e => handleInputChange(e)}
                        />
                    </ErrorInputWrap>
                    <div className="instruction-label pt1">Note: A password will be automatically generated and sent to the email entered.</div>
                    <div className="btn_container">
                        <Button
                            text="Add Specialist"
                            clickHandler={() => handleAddManager()}
                            isLoading={loading}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminManagersForm


// WEBPACK FOOTER //
// ./src/components/admin/managers/AdminManagersForm.js